export type CartQuote = { id: string } | null;

/**
 * Same decision as the quote list Edit action.
 * A cart quote is the user's document in Create status.
 * - navigate: the clicked quote is already the cart
 * - confirm: another quote is in the cart, so ask before changing status
 * - update: no cart quote, open the clicked quote
 */
export function decideQuoteOpen(
  clickedQuoteId: string,
  cart: CartQuote,
): "navigate" | "confirm" | "update" {
  if (!clickedQuoteId) return "navigate";
  if (cart?.id && String(cart.id) === String(clickedQuoteId)) return "navigate";
  if (cart) return "confirm";
  return "update";
}
